import { RectangleGroupIcon } from '@heroicons/react/24/outline'

import Breadcrumb from '@/components/navigation/Breadcrumb'

import { FiltersRow } from './filters/FiltersRow'
import { getColumns } from './table/Columns'
import { DataTable } from './table/DataTable'
import { TableContextProvider } from './table/TableContext'
import { useState } from 'react'
import { Vehicle } from '@/interfaces/vehicle'

export default function VehicleList() {
  const [showEditVehicle, setShowEditVehicle] = useState(false)
  const [showDeleteVehicle, setShowDeleteVehicle] = useState(false)
  const [vehicleToEdit, setVehicleToEdit] = useState<Vehicle>()
  const [vehicleToDelete, setVehicleToDelete] = useState<number>()

  return (
    <div>
      <Breadcrumb
        icon={<RectangleGroupIcon className="h-6 text-gray-500" />}
        paths={[{ name: 'Logística' }, { name: 'Vehículos' }]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable
          columns={getColumns(
            setShowEditVehicle,
            setVehicleToEdit,
            setShowDeleteVehicle,
            setVehicleToDelete
          )}
          onClose={() => setShowEditVehicle(false)}
          onCloseDelete={() => setShowDeleteVehicle(false)}
          showDeleteVehicle={showDeleteVehicle}
          showEditVehicle={showEditVehicle}
          vehicleToDelete={vehicleToDelete}
          vehicleToEdit={vehicleToEdit}
        />
      </TableContextProvider>
    </div>
  )
}
